<template>
  <RevInfoBlock
    :icon="IconContact"
    :title="i18n(translations.title)"
    variant="default"
  >
    <p>
      {{ i18n(translations.description) }}
    </p>

    <RevButton size="small" variant="primary" @click="handleActionClick">
      {{ i18n(translations.action) }}
    </RevButton>
  </RevInfoBlock>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { openModal } from '@ds/components/ModalBase'
import { IconContact } from '@ds/icons/IconContact'

import type { Order } from '~/scopes/orders/pages/components/Tab/Tab.types'
import { CONTACT_CUSTOMER_DRAWER_MODAL_NAME } from '~/scopes/orders/pages/components/Tab/components/Table/components/ActionCell/components/MoreActions/MoreActions.constants'
import { MODAL_NAME as FIX_ORDER_ISSUE_DRAWER_MODAL_NAME } from '~/scopes/orders/pages/components/Tab/components/Table/components/ActionCell/components/MoreActions/components/FixOrderIssueDrawer/FixOrderIssueDrawer.constants'

import translations from './Contact.translations'

const props = defineProps<{ order: Order }>()
const { FF_BO_SELLER_IS_REDUCE_SELLER_TO_CONTACTS_AGENT_OPEN } =
  useRuntimeConfig().public
const i18n = useI18n()

function handleActionClick() {
  if (FF_BO_SELLER_IS_REDUCE_SELLER_TO_CONTACTS_AGENT_OPEN) {
    openModal(FIX_ORDER_ISSUE_DRAWER_MODAL_NAME + props.order.id)
  } else {
    openModal(CONTACT_CUSTOMER_DRAWER_MODAL_NAME + props.order.id)
  }
}
</script>
